import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
  }).format(amount);
}

export function formatDate(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
}

export function formatDateTime(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}

export function getStatusColor(status) {
  switch (status) {
    case 'aprobado':
      return 'status-aprobado';
    case 'rechazado':
      return 'status-rechazado';
    case 'pendiente':
      return 'status-pendiente';
    case 'vencido':
      return 'status-vencido';
    case 'borrador':
    default:
      return 'status-borrador';
  }
}

export function getStatusLabel(status) {
  switch (status) {
    case 'aprobado':
      return 'Aprobado';
    case 'rechazado':
      return 'Rechazado';
    case 'pendiente':
      return 'Pendiente';
    case 'vencido':
      return 'Vencido';
    case 'borrador':
      return 'Borrador';
    default:
      return status;
  }
}

export function getStatusIcon(status) {
  switch (status) {
    case 'aprobado':
      return '🟢';
    case 'rechazado':
      return '🔴';
    case 'pendiente':
      return '🟡';
    case 'vencido':
      return '⏰';
    case 'borrador':
      return '📝';
    default:
      return '•';
  }
}

export function truncate(str, length = 50) {
  if (!str) return '';
  if (str.length <= length) return str;
  return str.slice(0, length) + '...';
}
